import { DATE_TIME_FORMAT, formatDateTime } from '@app/common/helpers/DateTime/DateTime'
import { UtilityBillCheck } from '@app/graphql/types'

export const formatUtilityBillMetaDataAsHtml = (utilityBillMetaData: UtilityBillCheck) => {
  let html = ''
  if (utilityBillMetaData.sizeOfFlat) {
    html += `<b>Wohnfläche in Quadratmeter:</b> ${utilityBillMetaData.sizeOfFlat}<br/><br/>`
  }

  if (utilityBillMetaData.moveInDate) {
    html += `<b>Einzugsdatum:</b> ${formatDateTime(
      utilityBillMetaData.moveInDate,
      DATE_TIME_FORMAT.DATE_FULL
    )}<br/><br/>`
  }

  if (utilityBillMetaData.isCurrentAddress || utilityBillMetaData.moveOutDate) {
    html += `<b>Auszugsdatum falls bereits ausgezogen:</b> ${
      utilityBillMetaData.isCurrentAddress
        ? 'noch aktuelle Wohnung'
        : formatDateTime(utilityBillMetaData.moveOutDate!, DATE_TIME_FORMAT.DATE_FULL)
    }<br/><br/>`
  }

  return html
}
